if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        const variantIdInput = this.form.querySelector('[name=id]');
        if (variantIdInput) variantIdInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (this.cart && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const cart = this.cart || document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.submitButton.querySelector('.loading__spinner');
        spinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id).join(',')
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(this.submitButton);
        }
        config.body = formData;

        const cartAddUrl = window.routes?.cart_add_url || routes?.cart_add_url;

        fetch(cartAddUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            cart.classList.remove('is-empty');

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.renderCartContents(cart, response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
              return;
            }

            this.renderCartContents(cart, response);
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(window.cartStrings?.error || 'Could not add to cart.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer?.classList.contains('is-empty')) {
              cartDrawer.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            spinner?.classList.add('hidden');
          });
      }

      renderCartContents(cart, response) {
        try {
          if (typeof cart.renderContents === 'function') {
            cart.renderContents(response);
            return;
          }

          if (typeof cart.open === 'function') {
            cart.open(this.submitButton);
          }
        } catch (error) {
          console.error('Cart drawer update failed:', error);

          if (cart.tagName === 'CART-DRAWER' && typeof cart.refreshDrawerFromCartPage === 'function') {
            cart.refreshDrawerFromCartPage();
            return;
          }

          if (typeof cart.open === 'function') {
            cart.open(this.submitButton);
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
